import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7610aa8d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7610aa8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610aa8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7610aa8d')) {
      api.createRecord('7610aa8d', component.options)
    } else {
      api.reload('7610aa8d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7610aa8d&scoped=true&", function () {
      api.rerender('7610aa8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Items/ProfileChange/index.vue"
export default component.exports